// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3GO4t","right":"Footer_right__1Bd97","buttons":"Footer_buttons__1XBlx"};